import styled from 'styled-components'

// Utils
import { breakpoint } from 'utils/breakpoint'

export const BannersContainer = styled.div`
  margin: 0 0 40px 0;

  ${breakpoint('base', 'sm')`
    margin: 40px 16px;
  `}
`
